import {
  useSharedState,
  useSharedStateWriteOnlyUpdater,
} from "../app/useSharedState";
import { TSceneActionUnion, updateScene } from "../Scene";
import { sendAction } from "./useEditorConnection";

export function useSceneAction() {
  const [, , updScene] = useSharedStateWriteOnlyUpdater("scene");
  const [ws] = useSharedState("serverSocket");

  const commit = (action: TSceneActionUnion) => {
    sendAction(ws, action);
    updScene((scene) => updateScene(scene, action));
  };

  return commit;
}
